import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DivisaoHonorariosFiltros, DivisaoHonrariosDTO } from '@app/models/divisao-honorarios.model';
import { IdDescricao } from '@app/models/util/id-descricao';
import { Paginacao } from '@app/models/util/paginacao';
import { ConsultasService } from '@app/services/consultas.service';
import { DivisaoHonorariosService } from '@app/services/divisao-honorarios.service';
import { CDSMask } from '@app/utils/cds-mask';
import debounce from '@app/utils/debounce';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-divisao-honorarios-lista',
  templateUrl: './divisao-honorarios-lista.component.html'
})

export class DivisaoHonorariosListaComponent implements OnInit {
vincular() {
  this.router.navigate(['financeiro/divisaoHonorarios/vincular']);
}
excluirDivisao(divisaoID: number) {
  this.divisaoService.ExcluirDivisao(divisaoID).toPromise().then(
    data => {
      if(data == true){
        this.toastr.success("Exclusão da divisão realizada");
        location.reload();
      }
      else{
        this.toastr.error("Exclusão da divisão não foi realizada");
      }
    }
  );
}

  constructor(private consultasService: ConsultasService,
    private divisaoService: DivisaoHonorariosService,
    @Inject(ToastrService) private toastr: ToastrService,
    private router: Router) { }

  paginacao: Paginacao = new Paginacao();
  lstTipoDR: IdDescricao[] = [];
  pesquisando: boolean;
  _pesquisa: any;
  _debounce: any;
  lstParticipante: Array<any> = [{}];
  cdsMask: CDSMask = new CDSMask();
  filtros: DivisaoHonorariosFiltros = new DivisaoHonorariosFiltros();
  loading: boolean = false;
  divisoes: DivisaoHonrariosDTO[] = [];

  ngOnInit() {

    this.consultasService
    .consultar('DR').toPromise()
    .then(data => this.lstTipoDR = data);

    this.pesquisarPaginator(this.filtros, 1);
  }

  pesquisar() {
    this.divisoes = [];
    this.paginacao.totalDeItens = 0;
    this.paginacao.paginaAtual = 1;
    this.paginacao.itensPorPagina = 10;
    this.pesquisarPaginator(this.filtros, 1);
  }

  pesquisarPaginator(filtros: DivisaoHonorariosFiltros, pagina: number) {

    this.pesquisando = true;
    filtros.Pagina = pagina;
    this.divisaoService.ListarDivisaoHonorarios(filtros).toPromise().then(
      data => {
        this.divisoes = data.divisoes;
        this.paginacao.totalDeItens = data.TotalDados;
        this.pesquisando = false;
      }, erro => {
        this.pesquisando = false;
         this.toastr.warning("Realize a pesquisa novamente.")
      });
  }

  public pageChanged(event: any): void {
    this.pesquisarPaginator(this.filtros, event.page);
  }

  
  verDivisao(divisaoId: number) {
    this.router.navigate(['financeiro/divisaoHonorarios/detalharDivisao', divisaoId]);
  }

}


